import { useParams } from 'react-router';
import type { TestProcedureRow } from '#shared/types';
import { Page } from '#client/components/ui/Page';
import { PageLoading, PageMessage } from '#client/components/ui/PageStatus';
import { useCan } from '#client/hooks/useCan';
import { useResourceItem } from '#client/hooks/useResourceItem';
import { RESOURCE, routes } from '#client/lib/routes';
import { TestProcedureCard } from './TestProcedureCard';
import { ButtonLink } from '#client/components/ui/ButtonLink';

export function TestProcedureDetailPage() {
  const { id } = useParams<{ id: string }>();
  const can = useCan();
  const procedure = useResourceItem<TestProcedureRow>(RESOURCE.testProcedures, id);

  if (procedure.loading) return <PageLoading title="Procedure" />;
  if (!procedure.data) {
    return <PageMessage title="Procedure not found">{procedure.error}</PageMessage>;
  }

  return (
    <Page
      title={procedure.data.title}
      subtitle={procedure.data.lab_test?.name ?? procedure.data.parameter?.name ?? undefined}
      backAction={
        <ButtonLink variant="secondary" size="md" to={routes.testProcedures}>
          All procedures
        </ButtonLink>
      }
    >
      <TestProcedureCard procedure={procedure.data} canWrite={can('procedure.edit')} />
    </Page>
  );
}
